// extracted by mini-css-extract-plugin
export default {"credentialsList":"myPortal_credentialsList__D9ROt"};